<template>
  <form @submit.prevent="confirm" class="main-modal">
    <div class="main-modal__title">
      {{ isUpdate === true ? $t("forms.updateBadge") : $t("forms.addBadge") }}
    </div>

    <div class="main-form__box">
      <label class="main-form__label">{{ $t("listsHeader.title") }}</label>
      <input
        class="main-form__input"
        v-validate="'required'"
        data-vv-as="field"
        name="name"
        type="text"
        v-model="form.name"
      />
    </div>

    <div class="main-form__box">
      <label class="main-form__label">{{ $t("forms.selectCategory") }}</label>
      <Select2
        :options="['main', 'funny']"
        :settings="{
          placeholder: $t('forms.selectCategory'),
          allowClear: false,
        }"
        class="select select2-container_w100"
        @select="selectMaster($event)"
        v-model="form.category"
      />
    </div>

    <div class="main-form__box">
      <label class="main-form__label">File</label>
      <div class="main-form__box custom-file">
        <!-- <input type="file" @change="setFile($event)" />
      <span class="form-category__span" v-if="isUpdate">
        {{ form.icon.text }}
      </span> -->

        <input
          type="file"
          multiple
          id="upload-file"
          @change="setFile($event)"
        />

        <label for="upload-file">
          <div class="svg-box">
            <svg
              width="20px"
              fill="var(--menu-text-color)"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 456.682 456.682"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M447.976,138.861c-7.544-9.4-18.776-14.568-30.824-14.568H399.24c-3.52-16-19.384-32-38.4-32H168
                                        c-13.232,0-24-10.768-24-24c0-22.056-17.944-40-40-40H40c-22.056,0-40,17.944-40,40v320c0,22.056,17.944,40,40,40h2.704
                                        c1.712,0.216,3.432,0,5.184,0H367c18.672,0,34.528-12.552,38.576-30.776l50.152-225.576
                                        C458.344,160.173,455.52,148.261,447.976,138.861z M16,68.293c0-13.232,10.768-24,24-24h64c13.232,0,24,10.768,24,24
                                        c0,22.056,17.944,40,40,40h192.832c10.136,0,18.752,8,21.88,16H97c-18.672,0-34.528,12.552-38.576,30.776L16,345.789V68.293z
                                        M439.416,168.325l-50.152,225.888c-2.336,10.512-11.488,18.08-22.264,18.08H47.888c-7.208,0-13.928-3.408-18.448-9.032
                                        c-4.504-5.624-6.192-12.976-4.632-20.008l49.92-224.872c2.336-10.512,11.496-18.08,22.264-18.08h320.152
                                        c6.96-0.008,13.44,3.28,17.8,8.704C439.296,154.437,440.92,161.533,439.416,168.325z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>

          <div>
            <span>{{ fileInputText }}</span>
          </div>
        </label>
      </div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span class="main-button main-button_cancel" @click="$emit('close')">{{
        $t("global.cancel")
      }}</span>
      <button class="main-button main-button_success" :disabled="!isValid">
        {{ isUpdate ? $t("global.edit") : $t("forms.create") }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    name: 'badges-modal',
    data() {
        return {
            load: false,
            fileInputText: this.$t('mails.chooseFile'),
        }
    },
    computed: {
        ...mapGetters({
            isUpdate: 'badges/isUpdate',
            item: 'badges/badge',
            form: 'badges/form',
        }),
        badge() {
            return this.item
        },
        isValid() {
            if (this.form.name === '' || this.form.name === null) {
                return false
            }

            if (this.form.category === '' || this.form.category === null) {
                return false
            }

            if (
                this.fileInputText === this.$t('mails.chooseFile')
        || this.fileInputText === null
            ) {
                return false
            }

            return true
        },
    },
    methods: {
        ...mapMutations({
            setState: 'badges/setState',
        }),
        ...mapActions({
            add: 'badges/add',
            update: 'badges/update',
        }),
        confirm() {
            // if (!this.isValid) {
            //     return;
            // }

            const form = this.prepareForm()

            this.isUpdate === true
                ? this.update({ form, id: this.badge.id })
                : this.add(form)

            this.setState({
                key: 'showModal',
                value: false,
            })
        },
        setFile({ target }) {
            const { files } = target

            if (files.length === 0) {
                return
            }

            let tmpName = ''
            files.forEach((element) => {
                tmpName += `${element.name} `
            })

            if (tmpName === '') {
                return
            }

            this.fileInputText = tmpName

            const file = files[0]
            this.form.icon.file = file
        },
        prepareForm() {
            this.form.category = this.form.category.toLowerCase()

            if (!this.isUpdate) {
                const fd = new FormData()
                fd.append('icon', this.form.icon.file)
                fd.append('name', this.form.name)
                fd.append('category', this.form.category)

                return fd
            }

            const def = {
                name: this.form.name,
                category: this.form.category,
            }
            return def
        },
    },
}
</script>

<style lang="scss" scoped>
// @import "src/assets/sass/main";

// form {
//   padding: 5px 25px 25px 25px;
//   width: 300px;
// }

// input:not([type="file"]) {
//   width: 300px;
//   height: 30px !important;
//   border-radius: 8px;
//   background-color: #ffffff;
//   border: 1px solid #e0e0e0;
//   font-family: "SFUIDisplay-Regular";
//   font-size: 16px;
//   color: #61422d;
//   padding-left: 20px;
//   -webkit-box-sizing: border-box;
//   box-sizing: border-box;
//   -webkit-transition: 0.5s;
//   transition: 0.5s;
//   max-width: 100%;
//   margin-bottom: 12px;
// }

// input[type="file"] {
//   display: block;
// }

// .form-actions {
//   display: flex;
//   margin-top: 20px;
// }

// .form-title {
//   font-size: 20px;
//   color: #71bd4a;
//   font-family: "SFUIDisplay-Medium";
//   text-align: center;
//   margin-bottom: 0;
//   padding-top: 20px;
// }

// form label {
//   display: inline-block;
//   margin-bottom: 5px;
// }

// form .button {
//   padding: 0 20px;
//   height: 40px !important;
//   border-radius: 8px;
//   background-color: #61422d;
//   -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//   border: none;
//   font-family: "SFUIDisplay-Bold";
//   font-size: 15px;
//   text-align: center;
//   color: #ffffff;
//   cursor: pointer;
//   -webkit-transition: 0.5s;
//   transition: 0.5s;
//   outline: none;
//   display: -webkit-box;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-pack: center;
//   -ms-flex-pack: center;
//   justify-content: center;
//   -webkit-box-align: center;
//   -ms-flex-align: center;
//   align-items: center;
//   margin: 10px;
// }

// .form-category {
//   margin-bottom: 10px;

//   &__span {
//     display: inline-block;
//     margin-top: 5px;
//   }
// }

// .main-button_disabled {
//   opacity: 0.5;
//   cursor: pointer;

//   &:hover {
//     background: #71bd4a !important;
//     color: #fff !important;
//   }
// }
</style>
